module.exports = __webpack_public_path__ + "vue-app/img/best-price-en.2d280693.svg";